/**
 * Loading spinner component.
 */

import './loading.scss';

export function LoadingSpinner({ size = 'md' }: { size?: 'sm' | 'md' | 'lg' }) {
  return (
    <div className="loading-spinner flex items-center justify-center">
      <div
        className={`loading-spinner__spinner loading-spinner__spinner--${size}`}
        role="status"
        aria-label="Loading"
      >
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
}

/**
 * Loading skeleton component.
 */
export function LoadingSkeleton({ className = '' }: { className?: string }) {
  return (
    <div className={`loading-skeleton ${className}`} aria-label="Loading" />
  );
}

